module.exports = __webpack_public_path__ + "static/media/trigger.ea07797e.mp3";